module.exports = __webpack_public_path__ + "static/media/spraying.8ff9f80e.mp4";